import { useState, useEffect } from 'react';
import { TbRefresh } from 'react-icons/tb';
import styles from './RefreshButton.module.css';

function RefreshButton({ onClick, loading, className = '' }) {
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    if (!loading) setSpinning(false);
  }, [loading]);

  function handleClick() {
    setSpinning(true);
    onClick?.();
  }

  return (
    <button
      className={`${styles.btn} ${className}`}
      onClick={handleClick}
      disabled={spinning && loading}
      aria-label="Refresh"
    >
      <TbRefresh size={16} className={spinning && loading ? styles.spinning : ''} />
    </button>
  );
}

export default RefreshButton;
